import { ListSubheader } from "@mui/material";

/**
 * @typedef {Object} CustomDropdownProps
 * @property {React.ReactNode} children
 */

/**
 * @param {CustomDropdownProps} param0
 * @returns {JSX.Element} Dropdown component
 */
const DropdownHeader = ({ children, sx = {} }) => {
  return (
    <ListSubheader
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
        pointerEvents: "none",
        color: "#6c757d",
        fontSize: "11px",
        padding: "0.5rem 1.5rem",
        whiteSpace: "nowrap",
        lineHeight: 1.5,
        fontWeight: "var(--bs-body-font-weight)",
        ...sx,
      }}
    >
      {children}
    </ListSubheader>
  );
};

export default DropdownHeader;
